import { LogoDrogasil } from './components/drogasil'
import { LogoPulso } from './components/pulso'
import { LogoRaia } from './components/raia'
import { LogoRDSaude } from './components/rd-saude'
import { LogoRDSaudeTagline } from './components/rd-saude-tagline'

export const Logo = {
  RDSaude: LogoRDSaude,
  Pulso: LogoPulso,
  Raia: LogoRaia,
  Drogasil: LogoDrogasil,
  RDSaudeTagline: LogoRDSaudeTagline,
}
